import { motion, useAnimation, useSpring, useTransform } from "framer-motion";
import { useEffect, useState } from "react";

const orbSize = 80;

const welcomingPhrases = [
  "Welcome to the battle zone!",
  "Hey, I'm I.O.! What's your name?... Wait, actually tell me when you pre-register!",
  "I scanned your aura... it's got champion potential!",
  "I’ve seen the stars…",
  "You look like someone who can handle a cosmic duel.",
  "If you find a rare card, I call dibs on naming it!",
  "Gear up, warrior!",
  "NFTs engaged.",
  "I’ve got a good feeling about you… and I don’t even have a stomach!",
  "You bring the strategy — I’ll bring the spark!",
];

const InfinityOrb = () => {
  const controls = useAnimation();
  const [frameIndex, setFrameIndex] = useState(0);
  const [showSpeech, setShowSpeech] = useState(false);
  const [speechText, setSpeechText] = useState(null);

  const ySpring = useSpring(0, {
    stiffness: 60,
    damping: 15,
  });

  // Hover effect: oscillate vertically
  useEffect(() => {
    const loop = () => {
      ySpring.set(-5);
      setTimeout(() => ySpring.set(5), 500);
      setTimeout(() => ySpring.set(-5), 1000);
    };
    const interval = setInterval(loop, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const sequence = async () => {
      // PATH 1: Bottom Right → Top Left
      setFrameIndex(2); // back-facing left
      await controls.start({
        left: "-2%",
        top: "-5%",
        opacity: 0,
        scale: 0.6,
        transition: { duration: 4, delay: 2 },
      });

      // PATH 2: Top Left → Top Right
      setFrameIndex(0); // back-facing right
      await controls.start({
        left: "105%",
        top: "10%",
        scale: 0.8,
        opacity: 1,
        transition: { duration: 5, delay: 2 },
      });

      // PATH 3: Top Right → Bottom Left
      setFrameIndex(1); // front-facing left
      await controls.start({
        left: "10%",
        top: "105%",
        scale: 2.5,
        opacity: 1,
        transition: { duration: 3.5, delay: 3 },
      });

      // PATH 4: Bottom Left → TO speaking positon
      setFrameIndex(0); // front-facing right
      await controls.start({
        left: "25%",
        top: "70%",
        scale: 1.5,
        opacity: 1,
        transition: { duration: 1.5, delay: 4 },
      });

      // PATH 5: Bottom Left → Bottom Right
      setFrameIndex(0); // front-facing right
      setSpeechText(
        welcomingPhrases[Math.floor(Math.random() * welcomingPhrases.length)]
      );
      setShowSpeech(true);
      await controls.start({
        left: "105%",
        top: "70%",
        scale: 1.5,
        opacity: 1,
        transition: { duration: 2.5, delay: 8 },
      });

      // Loop it
      sequence();
    };

    sequence();
  }, []);

  useEffect(() => {
    if (showSpeech && speechText) {
      setTimeout(() => {
        setShowSpeech(false);
      }, 5000);
    }

    if (!showSpeech && speechText && speechText.length > 0) {
      setSpeechText(null);
    }
  }, [showSpeech, speechText]);

  return (
    <>
      <motion.div
        animate={controls}
        style={{
          position: "absolute",
          width: orbSize,
          height: orbSize,
          zIndex: 10,
          y: ySpring,
        }}
      >
        {showSpeech && speechText && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: -40 }}
            exit={{ opacity: 0, y: -20 }}
            style={{
              position: "absolute",
              bottom: "60%",
              left: "30%",
              backgroundColor: "white",
              color: "black",
              height: "fit-content",
              borderRadius: "12px",
              fontSize: 12,
              width: "200%",
              textAlign: "center",
              zIndex: 10,
              boxShadow: "0 2px 10px rgba(0,0,0,0.25)",
            }}
          >
            <div
              style={{
                width: "100%",
                position: "relative",
                height: "100%",
                padding: "5px",
              }}
            >
              {speechText}
            </div>
          </motion.div>
        )}
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              height: "100%",
              width: "100%",
              position: "absolute",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundImage: `url(${require("../@shared/assets/sprites/infinityOrb-ns-sprite.png")})`,
              backgroundPosition: `-${frameIndex * orbSize}px 0px`,
              backgroundRepeat: "no-repeat",
              backgroundSize: `${orbSize * 4}px ${orbSize}px`,
              zIndex: 2,
            }}
          />
          <div
            style={{
              width: "50%",
              height: "58%",
              position: "absolute",
              top: "50%",
              left: frameIndex % 2 ? "50%" : "54%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "green",
              background: "radial-gradient(rgb(116, 249, 116),rgb(0, 41, 0))",
              borderRadius: "50%",
              zIndex: 1,
            }}
          />
        </div>
      </motion.div>
    </>
  );
};

export default InfinityOrb;
